import axios from 'axios';
import { BASE_URL } from 'shared/config';

import {
  errorHandler,
  responseMapper,
  setJWTHeader,
  setJWTLocalStorage,
} from './requestHelpers';

const request = axios.create({
  baseURL: BASE_URL,
});
request.interceptors.request.use(setJWTHeader());
request.interceptors.response.use(setJWTLocalStorage());
request.interceptors.response.use(responseMapper, errorHandler);

export { request };
